import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Grid,
	Button,
	TextField,
	Typography,
} from "@mui/material";

const initForm = {
	name: "",
	type: "",
}

class DialogCreateRole extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			form: {...initForm},
			onSubmit: null,
			isOpen: false,
			isLoading: false,
			isEdit: false,
		}
	}

	open = ({ onSubmit, editForm }) => {
		this.setState({
			onSubmit: onSubmit,
			form: Boolean(Object.keys(editForm || {}).length > 0) ? editForm : {...initForm},
			isOpen: true,
			isLoading: false,
			isEdit: Boolean(Object.keys(editForm || {}).length > 0),
		})
	}

	close = () => {
		this.setState({
			form: {...initForm},
			isOpen: false,
			isLoading: false,
			isEdit: false,
		})
	}

	resetLoading = () => {
		this.setState({ isLoading: false });
	}

	changeForm = ({ target }) => {
		const { value, name } = target;
		this.setState({
			form: {
				...this.state.form,
				[name]: value
			}
		});
	}

	submit = async () => {
		const { form, onSubmit } = this.state;
		
		if (!form.name || !form.name.trim()) {
			return;
		}

		this.setState({ isLoading: true });
		
		if (onSubmit) {
			await onSubmit(form);
		}
	}

	render() {
		const {
			form,
			isOpen,
			isLoading,
			isEdit
		} = this.state;

		if (!isOpen) {
			return null;
		}

		return (
			<Dialog
				open={isOpen}
				fullWidth
				maxWidth="sm"
				onClose={!isLoading ? this.close : undefined}
			>
				<DialogTitle>
					<Typography variant="h3">
						{isEdit ? "Редактирование роли" : "Создание новой роли"}
					</Typography>
				</DialogTitle>

				<DialogContent>
					<Grid container spacing={2} sx={{ paddingTop: 1 }}>
						<Grid item xs={12}>
							<TextField
								value={form.name}
								name="name"
								variant="outlined"
								size="small"
								label="Название роли"
								placeholder="Введите название роли"
								fullWidth
								disabled={isLoading}
								onChange={this.changeForm}
								onKeyPress={(e) => {
									if (e.key === 'Enter' && !isLoading && form.name?.trim()) {
										this.submit();
									}
								}}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								value={form.type || ''}
								name="type"
								variant="outlined"
								size="small"
								label="Тип роли"
								placeholder="Введите тип роли"
								fullWidth
								disabled={isLoading}
								onChange={this.changeForm}
							/>
						</Grid>
					</Grid>
				</DialogContent>

				<DialogActions>
					<Grid container spacing={2} justifyContent="flex-end" sx={{ px: 2, pb: 2 }}>
						<Grid item>
							<Button
								variant="outlined"
								onClick={this.close}
								disabled={isLoading}
							>
								Закрыть
							</Button>
						</Grid>
						<Grid item>
							<Button
								variant="contained"
								onClick={this.submit}
								disabled={isLoading || !form.name?.trim()}
							>
								{isEdit ? "Сохранить" : "Создать"}
							</Button>
						</Grid>
					</Grid>
				</DialogActions>
			</Dialog>
		)
	}
}

export default DialogCreateRole

